import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../../constants/svgIcon';
import {
  LoadMoreSpinner,
  ScrollArrows,
  StationCell,
  StationCellProps,
  SvgIcon,
} from '../../../Molecules';

import styles from './GameListTemplateV2.module.css';

export type GameListTemplateV2Props = {
  title: string;
  stations: StationCellProps[];
  hasCursor: boolean;
  onClickBack: () => void;
  loadMoreItems: () => void;
};

export const GameListTemplateV2 = memo(
  ({
    title,
    stations,
    hasCursor,
    onClickBack,
    loadMoreItems,
  }: GameListTemplateV2Props) => {
    const { t } = useTranslation();
    // const [searchQuery, setSearchQuery] = useState('');
    // const [displayedList, setDisplayedList] = useState(stations);
    // const stationNumber = stations.length;

    // const onClickSearch = useCallback(() => {
    //   const iniList = stations;
    //   const filteredList = iniList.filter((station) => {
    //     const searchTerm = searchQuery.toLowerCase().trim();

    //     if (station.type !== StationCellType.Game) return false;

    //     const gameProps = station.props;
    //     const game = gameProps.game;

    //     const gameResources = game.i18nGameData.resources;
    //     const defaultLocale = game.i18nGameData.defaultLocale;
    //     const gameTitle =
    //       gameResources[defaultLocale]?.title?.toLowerCase() || '';

    //     const variants = gameResources[defaultLocale]?.variants || [];
    //     const answerTexts = variants.flatMap((variant) => {
    //       if ('answer' in variant && 'words' in variant.answer) {
    //         return variant.answer.words.map((word) => word.word.toLowerCase());
    //       }
    //       return [];
    //     });

    //     const gameTypeKey = gameProps.iconKey;
    //     const gameTypeDisplayName =
    //       getGameTypeDetails(gameTypeKey).displayName.toLowerCase();

    //     const searchTerms = searchTerm
    //       .split(' ')
    //       .filter((term) => term.length > 0);

    //     return searchTerms.every(
    //       (term) =>
    //         gameTitle.includes(term) ||
    //         gameTypeDisplayName.includes(term) ||
    //         answerTexts.some((text) => text.includes(term)),
    //     );
    //   });

    //   setDisplayedList(filteredList);
    // }, [stations, searchQuery]);

    return (
      <div className={styles.gameList}>
        <ScrollArrows />
        <div className={styles.titleRow}>
          <div className={styles.iconContainer} onClick={onClickBack}>
            <SvgIcon
              name={SVGIconType.Arrow}
              color={'#808080'}
              width={30}
              height={30}
              style={{ transform: 'scaleX(-1)' }}
            />
          </div>
          <p className={styles.title}>{t(title)}</p>
        </div>
        <hr />
        {/* <div className={styles.searchContainer}>
          {stationNumber >= 10 ? (
            <SearchBar
              placeholder={t('Search')}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onSearch={onClickSearch}
              backgroundColor={'white'}
              webPageType={WebPageType.JOYAJOY}
            />
          ) : null}
        </div> */}
        <div className={`listContainerInPerformance ${styles.listContainer}`}>
          {stations.map((item, index) => (
            <StationCell key={index} {...item} />
          ))}
        </div>

        {hasCursor && (
          <LoadMoreSpinner
            hasCursor={hasCursor}
            loadMoreItems={loadMoreItems}
          />
        )}
      </div>
    );
  },
);
